// Shared config for level-specific academic fields.
// Kenya's CBC secondary level is Senior School (Grade 10-12) as of Jan 2026.
// Legacy Form 3/4 kept for the remaining 8-4-4 cohort.

export const FORM_GRADE_OPTIONS = [
  { value: "GRADE_10", label: "Grade 10 (Senior School)" },
  { value: "GRADE_11", label: "Grade 11 (Senior School)" },
  { value: "GRADE_12", label: "Grade 12 (Senior School)" },
  { value: "FORM_3",   label: "Form 3 (8-4-4, legacy)" },
  { value: "FORM_4",   label: "Form 4 (8-4-4, legacy)" },
];

export const SENIOR_SCHOOL_GRADES = ["GRADE_10", "GRADE_11", "GRADE_12"];

export const PATHWAY_OPTIONS = [
  { value: "STEM",            label: "STEM" },
  { value: "SOCIAL_SCIENCES", label: "Social Sciences" },
  { value: "ARTS_SPORTS",     label: "Arts & Sports Science" },
];

export const COURSE_LEVEL_OPTIONS = [
  { value: "CERTIFICATE", label: "Certificate" },
  { value: "DIPLOMA",     label: "Diploma" },
];

export const LEVEL_DESCRIPTIONS = {
  SECONDARY:  "Enter your current school and grade/form information.",
  COLLEGE:    "Enter your current college and course information.",
  UNIVERSITY: "Enter your current university and course information.",
};

export const getOptionLabel = (options, value) =>
  options.find((o) => o.value === value)?.label || value || "Not provided";